/* eslint-disable react/no-array-index-key */
/* global ChoiceOption */
import React from 'react';
import { styled } from '@mui/material/styles';
import {
  FormControlLabel, Typography, Card, CardContent,
  FormGroup, Checkbox,
} from '@mui/material';
import { ChangeEvent } from './column-filter.types';
import { getFilteredSelected } from './helpers';

const StyledCardContent = styled(CardContent)({
  padding: 0,
  maxHeight: 350,
  '&:last-child': {
    padding: 0,
  },
});

const StyledFormGroup = styled(FormGroup, {
  shouldForwardProp: (prop) => prop !== 'options',
})<{options: number}>(({ theme, options }) => ({
  padding: theme.spacing(1.25),
  ...(options > 3 && {
    maxHeight: 108,
    overflow: 'auto',
    flexWrap: 'nowrap',
  }),
}));

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  padding: theme.spacing(0.5),
}));

interface Props {
  values: ChoiceOption[]
  selected: ChoiceOption[];
  onChange: (item: ChoiceOption) => (e: ChangeEvent) => void;
}

const ColumnFilterSelectedBox: React.FC<Props> = ({ ...props }) => (
  <>
    <Typography pt={1} pb={1}>{`Selected (${props.selected.length})`}</Typography>
    <Card variant="outlined">
      <StyledCardContent>
        <StyledFormGroup options={props.selected.length}>
          {getFilteredSelected(props.selected, props.values)
            .map((item: ChoiceOption) => (
              <FormControlLabel
                sx={{ margin: 0, paddingBottom: 0.5 }}
                key={item.value}
                label={item.label}
                control={(
                  <StyledCheckbox
                    checked
                    name={item.label}
                    onChange={props.onChange(item)}
                  />
                )}
              />
            ))}
        </StyledFormGroup>
      </StyledCardContent>
    </Card>
  </>
);

export default ColumnFilterSelectedBox;
